import { BLOB_ID } from '../../../constants/blobId';
import { ChatMessageValidationError } from '../../../errors';
import { showAlert } from '../../../slices/alertSlice';
import { EAlert } from '../../../types/alert';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageValidationError } from '../actions';
import { trackOpenForbiddenTextPopup } from '../tracking';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertForbiddenTextStatus =
  (response: TFirstMessageResponse, { domain, telemetry, text }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.ForbiddenText) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendContainsForbiddenText);

      const { data: modalWarning } = response;

      dispatch(setFirstMessageValidationError());
      dispatch(
        showAlert({
          type: EAlert.MessageСontainsForbiddenText,
          message: text,
          modalWarning,
          chatId: BLOB_ID,
        }),
      );

      trackOpenForbiddenTextPopup();

      const error = new ChatMessageValidationError({
        message: 'Не удалось отправить первое сообщение: текст содержит запрещённые слова',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
